import { DtIconCodeBlock as O, DtIconCode as T, DtIconQuote as x, DtIconListOrdered as E, DtIconStrikethrough as S, DtIconItalic as v, DtIconBold as A, DtIconListBullet as y } from "@dialpad/dialtone-icons/vue3";
import I from "./message-input-button.js";
import { DialtoneLocalization as g } from "../../localization/index.js";
import { resolveComponent as a, openBlock as D, createBlock as N, withCtx as n, createVNode as i, createElementVNode as r, renderSlot as f } from "vue";
import { _ as U } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import h from "../stack/stack.js";
const C = {
  compatConfig: { MODE: 3 },
  name: "DtRecipeMessageInputTopbar",
  components: {
    DtStack: h,
    DtIconListBullet: y,
    DtIconBold: A,
    DtIconItalic: v,
    DtIconStrikethrough: S,
    DtIconListOrdered: E,
    DtIconQuote: x,
    DtIconCode: T,
    DtIconCodeBlock: O,
    DtRecipeMessageInputButton: I
  },
  props: {
    boldButtonOptions: {
      type: Object,
      default: () => ({})
    },
    italicButtonOptions: {
      type: Object,
      default: () => ({})
    },
    strikeButtonOptions: {
      type: Object,
      default: () => ({})
    },
    bulletListButtonOptions: {
      type: Object,
      default: () => ({})
    },
    orderedListButtonOptions: {
      type: Object,
      default: () => ({})
    },
    blockQuoteButtonOptions: {
      type: Object,
      default: () => ({})
    },
    codeButtonOptions: {
      type: Object,
      default: () => ({})
    },
    codeBlockButtonOptions: {
      type: Object,
      default: () => ({})
    },
    isSelectionActive: {
      type: Function,
      default: () => {
      }
    }
  },
  emits: ["click"],
  data() {
    return {
      i18n: new g()
    };
  },
  computed: {
    boldButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_BOLD_BUTTON_LABEL");
    },
    italicButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_ITALIC_BUTTON_LABEL");
    },
    strikeButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_STRIKETHROUGH_BUTTON_LABEL");
    },
    bulletListButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_BULLET_LIST_BUTTON_LABEL");
    },
    orderedListButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_ORDERED_LIST_BUTTON_LABEL");
    },
    blockQuoteButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_BLOCK_QUOTE_BUTTON_LABEL");
    },
    codeButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_CODE_BUTTON_LABEL");
    },
    codeBlockButtonLabel() {
      return this.i18n.$ta("DIALTONE_MESSAGE_INPUT_CODE_BLOCK_BUTTON_LABEL");
    }
  }
};
function q(c, t, e, M, z, o) {
  const u = a("dt-icon-bold"), s = a("dt-recipe-message-input-button"), d = a("dt-icon-italic"), b = a("dt-icon-strikethrough"), _ = a("dt-icon-list-bullet"), k = a("dt-icon-list-ordered"), p = a("dt-icon-quote"), B = a("dt-icon-code"), L = a("dt-icon-code-block"), m = a("dt-stack");
  return D(), N(m, {
    direction: "row",
    gap: "200",
    class: "d-recipe-message-input__button-stack"
  }, {
    default: n(() => [
      i(s, {
        "aria-label": o.boldButtonLabel["aria-label"],
        "tooltip-text": o.boldButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.boldButtonOptions.keyboardShortcutText,
        "data-qa": "bold",
        "is-active": e.isSelectionActive("bold"),
        onClick: t[0] || (t[0] = (l) => c.$emit("click", "bold", l))
      }, {
        icon: n(() => [
          i(u, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"]),
      i(s, {
        "aria-label": o.italicButtonLabel["aria-label"],
        "tooltip-text": o.italicButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.italicButtonOptions.keyboardShortcutText,
        "data-qa": "italic",
        "is-active": e.isSelectionActive("italic"),
        onClick: t[1] || (t[1] = (l) => c.$emit("click", "italic", l))
      }, {
        icon: n(() => [
          i(d, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"]),
      i(s, {
        "aria-label": o.strikeButtonLabel["aria-label"],
        "tooltip-text": o.strikeButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.strikeButtonOptions.keyboardShortcutText,
        "data-qa": "strikethrough",
        "is-active": e.isSelectionActive("strike"),
        onClick: t[2] || (t[2] = (l) => c.$emit("click", "strike", l))
      }, {
        icon: n(() => [
          i(b, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"]),
      t[8] || (t[8] = r("div", { class: "d-recipe-message-input--button-group-divider" }, null, -1)),
      f(c.$slots, "link"),
      t[9] || (t[9] = r("div", { class: "d-recipe-message-input--button-group-divider" }, null, -1)),
      i(s, {
        "aria-label": o.bulletListButtonLabel["aria-label"],
        "tooltip-text": o.bulletListButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.bulletListButtonOptions.keyboardShortcutText,
        "data-qa": "bullet-list",
        "is-active": e.isSelectionActive("bulletList"),
        onClick: t[3] || (t[3] = (l) => c.$emit("click", "bulletList", l))
      }, {
        icon: n(() => [
          i(_, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"]),
      i(s, {
        "aria-label": o.orderedListButtonLabel["aria-label"],
        "tooltip-text": o.orderedListButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.orderedListButtonOptions.keyboardShortcutText,
        "data-qa": "ordered-list",
        "is-active": e.isSelectionActive("orderedList"),
        onClick: t[4] || (t[4] = (l) => c.$emit("click", "orderedList", l))
      }, {
        icon: n(() => [
          i(k, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"]),
      t[10] || (t[10] = r("div", { class: "d-recipe-message-input--button-group-divider" }, null, -1)),
      i(s, {
        "aria-label": o.blockQuoteButtonLabel["aria-label"],
        "tooltip-text": o.blockQuoteButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.blockQuoteButtonOptions.keyboardShortcutText,
        "data-qa": "blockquote",
        "is-active": e.isSelectionActive("blockquote"),
        onClick: t[5] || (t[5] = (l) => c.$emit("click", "blockquote", l))
      }, {
        icon: n(() => [
          i(p, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"]),
      t[11] || (t[11] = r("div", { class: "d-recipe-message-input--button-group-divider" }, null, -1)),
      i(s, {
        "aria-label": o.codeButtonLabel["aria-label"],
        "tooltip-text": o.codeButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.codeButtonOptions.keyboardShortcutText,
        "data-qa": "code",
        "is-active": e.isSelectionActive("code"),
        onClick: t[6] || (t[6] = (l) => c.$emit("click", "code", l))
      }, {
        icon: n(() => [
          i(B, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"]),
      i(s, {
        "aria-label": o.codeBlockButtonLabel["aria-label"],
        "tooltip-text": o.codeBlockButtonLabel["tooltip-text"],
        "keyboard-shortcut-text": e.codeBlockButtonOptions.keyboardShortcutText,
        "data-qa": "code-block",
        "is-active": e.isSelectionActive("codeBlock"),
        onClick: t[7] || (t[7] = (l) => c.$emit("click", "codeBlock", l))
      }, {
        icon: n(() => [
          i(L, {
            class: "d-recipe-message-input__button-stack-icon",
            size: "200"
          })
        ]),
        _: 1
      }, 8, ["aria-label", "tooltip-text", "keyboard-shortcut-text", "is-active"])
    ]),
    _: 3
  });
}
const K = /* @__PURE__ */ U(C, [["render", q]]);
export {
  K as default
};
//# sourceMappingURL=message-input-topbar.js.map
